<footer class="footer-responsive primary-bgpurple">
  <div class="container">
    <div class="row">
      <div class="col-lg-3   col-md-6 offset-lg-1 ">
        <div class="accordion-item">
          <h6 class="accordion-header" id="h1">
            <a class="accordion-button" aria-expanded="true" aria-controls="c1">
              IMPORTANT LINKS
            </a>
          </h6>
          <div id="c1" class="accordion-collapse collapse show" aria-labelledby="h1" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <ul>
                <li><a href="https://currentopenings.raisoni.net/" target="_blank">Current Opening</a></li>
                <li><a routerLink="/about-iqac">IQAC</a></li>
                <li><a routerLink="/placement-process">Placement</a></li>
                <li><a routerLink="/faq" target="_blank">Faqs</a></li>
                <li><a routerLink="/testimonials" target="_blank">Testimonials</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2  col-md-6">
        <div class="accordion-item">
          <h6 class="accordion-header" id="h2">
            <a class="accordion-button" aria-expanded="true" aria-controls="c2">
              PORTALS
            </a>
          </h6>
          <div id="c2" class="accordion-collapse collapse show" aria-labelledby="h2" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <ul>
                <li><a href="https://alumni.raisoni.net/" target="_blank">Alumni Portal</a></li>
                <li><a href="https://raisoni.net/placement" target="_blank">RGI Placement</a></li>
                <li><a href="https://www.rashtriyachhatrasansad.in/" target="_blank">NSP</a></li>
                <li><a href="http://nationalagricultureconclave.com/" target="_blank">NAC</a></li>
                <li><a href="https://sgrkf.com/" target="_blank">SGRKF</a></li>
                <li><a href="http://ghrscf.com/" target="_blank">GHRSCF</a></li>
                <li><a href="https://oclfnagpur.com/" target="_blank">OCLF</a></li>
              </ul>
            </div>
          </div>
        </div>

      </div>
      <div class="col-lg-3  col-md-6">
        <div class="accordion-item">
          <h6 class="accordion-header" id="h3">
            <a class="accordion-button" aria-expanded="true" aria-controls="c3">
              COLLEGE HIGHLIGHTS
            </a>
          </h6>
          <div id="c3" class="accordion-collapse collapse show" aria-labelledby="h3" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <ul>
                <li><a routerLink="/events">Toastmasters</a></li>
                <li><a routerLink="/hostel">Hostel</a></li>
                <li><a routerLink="/events">Events</a></li>
                <li><a routerLink="/library">Library</a></li>
                <li><a routerLink="/labs">Labs</a></li>
                <li><a routerLink="/events">Sports</a></li>
              </ul>
            </div>
          </div>
        </div>

      </div>
      <div class="col-lg-3  col-md-6">
        <div class="accordion-item">
          <h6 class="accordion-header" id="h4">
            <a class="accordion-button" aria-expanded="true" aria-controls="c4">
              contacts
            </a>
          </h6>
          <div id="c4" class="accordion-collapse collapse show" aria-labelledby="h4" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <ul class="contact">
                <li>
                  <a href="https://g.page/GHRCE?share" target="_blank"> <i class="fa fa-map-marker"></i>GHRCACS 'D'
                    building, Domkhel road, Gate No. 1200 Wagholi, Pune – 412207.</a>

                </li>
                <li>
                  <a href="tel:8669950061"><span>IQAC Coordinator-&nbsp;</span>+91-8669950061</a><br>
                  <a href="tel:#"><span>For Admission Inquiry: </span>8605625522/7720088580/ 7720089274/7720089275</a>

                </li>
                <li>
                  <a href="mailto:ghrcacs.pune@raisoni.net">ghrcacs.pune@raisoni.net</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="row mt-lg-3 justify-content-between flex-row-reverse">
      <div class="col-lg-3  offset-lg-2">
        <div class="social-links">
          <a href="https://www.facebook.com/raisoniworld" target="_blank"><i class="fa  fa-facebook"></i>
          </a>
          <a href="https://twitter.com/raisoniworld" target="_blank"><i class="fa fa-x-twitter "></i>
          </a>
          <a href="https://www.linkedin.com/school/raisoniworld" target="_blank"><i class="fa fa-linkedin"></i> </a>
          <a href="http://youtube.com/raisoniworld" target="_blank"><i class="fa fa-youtube"></i>
          </a>
          <a href="https://instagram.com/raisoniworld" target="_blank"><i class="fa fa-instagram"></i>
          </a>
        </div>
      </div>
      <div class="col-lg-6 col-xxl-7">
        <div class="footer-dome my-4 my-lg-0 position-relative">
          <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/footer-dome-white.webp"
            alt="GHRCACS, PUNE" class="img-fluid">
        </div>
      </div>
    </div>
    <div class="row mt-lg-3 justify-content-between flex-row-reverse">
      <div class="col-lg-5">
        <div class="text-end">
          <a href="https://raisoni.net/document/privacy_policy.html" target="_blank">Privacy Policy</a> | <a
            href="https://raisoni.net/document/terms_and_conditions.html" target="_blank"> Terms &amp;
            Conditions</a> | <a href="https://raisoni.net/document/refund_and_cancellation.html" target="_blank">Refund
            &amp; Cancellation </a>
        </div>
      </div>
      <div class="col-lg-6 offset-lg-1">
        <p class="mb-0">&copy; {{ date }} All Rights Reserved. Design & Developed by <a href="https://globaledu.net.in/"
            target="_blank">Global
            Education Limited.</a>
        </p>
      </div>
    </div>
  </div>
</footer>

<!-- floating tab  -->
<div class="sticky-bar int-sticky-bar">
  <ul>
    <li>
      <a href="https://api.whatsapp.com/send/?phone=917774008603&amp;text=Hi, I need assistance for Admission at your Raisoni Education for Academic Year 2026-27"
        target="_blank">
        <div class="icon"><i class="fa fa-whatsapp"></i></div>
        <div class="st-label">Whatsapp Chat</div>
      </a>
    </li>
    <!-- <li>
            <a href="mailto:admissions@raisoni.net">
                <div class="icon"><i class="fa fa-envelope"></i></div>
                <div class="st-label">Mail Us</div>
            </a>
        </li> -->
    <li class="conference-tab" style="margin-left: -122px;"><a href="https://currentopenings.raisoni.net/"
        target="_blank">
        <div class="icon"><i class="fa fa-edit"></i></div>
        <div class="st-label">Current Opening</div>
      </a></li>

    <!-- <li>
            <a href="mailto:admissions@raisoni.net">
                <div class="icon"><i class="fa fa-envelope"></i></div>
                <div class="st-label">Mail Us</div>
            </a>
        </li> -->

    <li>
      <a href="https://raisoni.nopaperforms.com/rgi" target="_blank">
        <div class="icon"><i class="fa fa-edit"></i></div>
        <div class="st-label">Apply Now</div>
      </a>
    </li>
  </ul>
</div>

<button class="trigger_popup" id="myBtn">Enquire Now</button>
<div id="enq-modal" class="enquiry-modal" data-backdrop="static" data-keyboard="false" style="display: none;">
  <div class="modal-content">
    <div class="head_text">Enquire Now</div>
    <button class="close" onclick="document.getElementById('enq-modal').style.display='none'">&times;</button>
    <div class="npf_wgts" data-height="480px" data-w="6d304e2e2cfdd5a0de90fc360591677e">
      <iframe frameborder="0" width="100%" height="480px" sandbox="allow-top-navigation allow-scripts allow-same-origin"
        src="https://widgets.nopaperforms.com/register?&amp;r=&amp;q=&amp;w=6e2d938a8f42987637737ee22606670f&amp;m=&amp;cu=https://www.raisoni.net/media/photo-gallery/"></iframe>
    </div>
  </div>
</div>
<!-- chat box -->
<div class="npf_chatbots" data-w="9d4303fa6f5d402cb4dcd0e0b7c88f29" style="display:none;"></div>


<!-- scroll to top button -->
<button *ngIf="isShow" (click)="gotoTop()" class="scrollTop">
  <i class="flaticon flaticon-up-arrow"></i>
</button>
